// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { FaCalendar, FaUser, FaEye } from 'react-icons/fa';
// import { AppContext } from '../App';

// const Blogs = () => {
//   const { blogs } = useContext(AppContext);
//   const publishedBlogs = blogs.filter(b => b.isPublished).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

//   return (
//     <>
//       <Helmet>
//         <title>Financial Blogs & Articles - Wisdom Consultancy | Expert Insights</title>
//         <meta name="description" content="Read expert articles on investment, mutual funds, insurance, retirement planning, and financial management. Stay updated with latest financial insights." />
//       </Helmet>

//       {/* Hero Section */}
//       <div className="bg-gradient-to-r from-primary to-secondary py-16">
//         <div className="container-custom text-center text-white">
//           <motion.h1
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-4xl md:text-5xl font-bold mb-4"
//           >
//             Financial Insights Blog
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.1 }}
//             className="text-xl opacity-90 max-w-3xl mx-auto"
//           >
//             Expert articles, tips, and insights for your financial journey
//           </motion.p>
//         </div>
//       </div>

//       {/* Blog Grid */}
//       <section className="py-20 bg-gray-50">
//         <div className="container-custom">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {publishedBlogs.map((blog, index) => (
//               <motion.article
//                 key={blog.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 group"
//               >
//                 {blog.image && (
//                   <div className="h-48 overflow-hidden">
//                     <img
//                       src={blog.image}
//                       alt={blog.title}
//                       className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
//                     />
//                   </div>
//                 )}
//                 <div className="p-6">
//                   <div className="flex items-center gap-4 text-xs text-gray-500 mb-3">
//                     <span className="flex items-center gap-1"><FaCalendar /> {blog.createdAt}</span>
//                     <span className="flex items-center gap-1"><FaUser /> {blog.author}</span>
//                     <span className="flex items-center gap-1"><FaEye /> {blog.views} views</span>
//                   </div>
//                   <h2 className="text-xl font-bold text-primary mb-2 line-clamp-2">{blog.title}</h2>
//                   <p className="text-gray-600 mb-4 line-clamp-3">{blog.excerpt}</p>
//                   <div className="flex flex-wrap gap-2 mb-4">
//                     {blog.tags?.slice(0, 3).map((tag, idx) => (
//                       <span key={idx} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">#{tag}</span>
//                     ))}
//                   </div>
//                   <Link
//                     to={`/blogs/${blog.slug}`}
//                     className="inline-flex items-center gap-2 text-accent font-semibold hover:gap-3 transition-all"
//                   >
//                     Read More →
//                   </Link>
//                 </div>
//               </motion.article>
//             ))}
//           </div>

//           {publishedBlogs.length === 0 && (
//             <div className="text-center py-12">
//               <p className="text-gray-500">No blog posts yet. Check back soon for financial insights!</p>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default Blogs;

// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';

// import {
//   FaCalendar,
//   FaUser,
//   FaEye,
//   FaArrowRight,
//   FaChartLine,
// } from 'react-icons/fa';

// import { AppContext } from '../App';

// const Blogs = () => {
//   const { blogs } = useContext(AppContext);

//   const publishedBlogs = blogs
//     .filter((b) => b.isPublished)
//     .sort(
//       (a, b) =>
//         new Date(b.createdAt) - new Date(a.createdAt)
//     );

//   return (
//     <>
//       <Helmet>
//         <title>
//           Financial Blogs & Articles - Wisdom Consultancy
//         </title>

//         <meta
//           name="description"
//           content="Read expert articles on investment, mutual funds, insurance, retirement planning, and financial management."
//         />
//       </Helmet>

//       {/* MAIN SECTION */}
//       <section className="relative overflow-hidden bg-[#f5f7f6] min-h-screen">
//         {/* GRID BACKGROUND */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #d7d7d7 1px, transparent 1px),
//               linear-gradient(to bottom, #d7d7d7 1px, transparent 1px)
//             `,
//             backgroundSize: '42px 42px',
//           }}
//         />

//         <div className="container-custom relative z-10 py-20">
//           {/* HERO SECTION */}
//           <div className="text-center max-w-4xl mx-auto mb-20">
//             {/* TOP BADGE */}
//             <div className="inline-flex items-center gap-3 bg-white shadow-md px-5 py-3 rounded-full mb-8">
//               <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
//                 <FaChartLine />
//               </div>

//               <span className="font-semibold text-[#0b1c39]">
//                 Financial Knowledge Hub
//               </span>
//             </div>

//             {/* HEADING */}
//             <motion.h1
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               className="text-5xl md:text-7xl font-extrabold leading-tight text-[#222]"
//             >
//               Financial{' '}
//               <span className="text-[#69bf74]">
//                 Insights
//               </span>{' '}
//               Blog
//             </motion.h1>

//             {/* DESCRIPTION */}
//             <motion.p
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.1 }}
//               className="mt-8 text-lg md:text-xl text-gray-600 leading-9"
//             >
//               Expert articles, smart investment tips and
//               financial insights to guide your wealth journey.
//             </motion.p>
//           </div>

//           {/* BLOG GRID */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//             {publishedBlogs.map((blog, index) => (
//               <motion.article
//                 key={blog.id}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 className="group bg-white rounded-[32px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-transparent hover:border-[#dbe7ff]"
//               >
//                 {/* IMAGE */}
//                 {blog.image && (
//                   <div className="relative h-56 overflow-hidden">
//                     <img
//                       src={blog.image}
//                       alt={blog.title}
//                       className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                     />

//                     {/* OVERLAY */}
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
//                   </div>
//                 )}

//                 {/* CONTENT */}
//                 <div className="p-7">
//                   {/* META */}
//                   <div className="flex flex-wrap gap-4 text-xs text-gray-500 mb-5">
//                     <span className="flex items-center gap-2">
//                       <FaCalendar className="text-[#2e56b8]" />
//                       {blog.createdAt}
//                     </span>

//                     <span className="flex items-center gap-2">
//                       <FaUser className="text-[#69bf74]" />
//                       {blog.author}
//                     </span>

//                     <span className="flex items-center gap-2">
//                       <FaEye className="text-[#2e56b8]" />
//                       {blog.views} views
//                     </span>
//                   </div>

//                   {/* TITLE */}
//                   <h2 className="text-2xl font-bold text-[#0b1c39] leading-snug mb-4 line-clamp-2 group-hover:text-[#2e56b8] transition-colors">
//                     {blog.title}
//                   </h2>

//                   {/* EXCERPT */}
//                   <p className="text-gray-600 leading-8 mb-6 line-clamp-3">
//                     {blog.excerpt}
//                   </p>

//                   {/* TAGS */}
//                   <div className="flex flex-wrap gap-3 mb-7">
//                     {blog.tags?.slice(0, 3).map((tag, idx) => (
//                       <span
//                         key={idx}
//                         className="text-xs bg-[#edf3ff] text-[#2e56b8] px-3 py-2 rounded-full font-medium"
//                       >
//                         #{tag}
//                       </span>
//                     ))}
//                   </div>

//                   {/* BUTTON */}
//                   <Link
//                     to={`/blogs/${blog.slug}`}
//                     className="inline-flex items-center gap-3 text-[#2e56b8] font-semibold text-lg hover:gap-5 transition-all duration-300"
//                   >
//                     Read More
//                     <FaArrowRight />
//                   </Link>
//                 </div>
//               </motion.article>
//             ))}
//           </div>

//           {/* EMPTY STATE */}
//           {publishedBlogs.length === 0 && (
//             <div className="text-center py-24">
//               <div className="bg-white rounded-[30px] shadow-xl p-12 max-w-2xl mx-auto">
//                 <h3 className="text-3xl font-bold text-[#0b1c39] mb-4">
//                   Blogs Coming Soon
//                 </h3>

//                 <p className="text-gray-600 text-lg leading-8">
//                   No blog posts available right now.
//                   Stay tuned for expert financial tips and
//                   investment insights.
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default Blogs;

import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

import {
  FaCalendarAlt,
  FaUserAlt,
  FaEye,
  FaArrowRight,
  FaChartLine,
} from 'react-icons/fa';

import { AppContext } from '../App';

const Blogs = () => {
  const { blogs } = useContext(AppContext);

  const publishedBlogs = blogs
    .filter((b) => b.isPublished)
    .sort(
      (a, b) =>
        new Date(b.createdAt) - new Date(a.createdAt)
    );

  return (
    <>
      <Helmet>
        <title>
          Financial Blogs & Articles | Wisdom Consultancy
        </title>

        <meta
          name="description"
          content="Read expert articles on investment, mutual funds, insurance, SIPs, retirement planning, and smart financial management from Wisdom Consultancy."
        />
      </Helmet>

      {/* MAIN SECTION */}
      <section className="relative overflow-hidden bg-[#f5f7f6] min-h-screen">
        {/* GRID BACKGROUND */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #d7d7d7 1px, transparent 1px),
              linear-gradient(to bottom, #d7d7d7 1px, transparent 1px)
            `,
            backgroundSize: '42px 42px',
          }}
        />

        {/* BLUR SHAPES */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#edf3ff] rounded-full blur-3xl opacity-60" />

        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#dff5eb] rounded-full blur-3xl opacity-60" />

        <div className="container-custom relative z-10 py-20">
          {/* HERO SECTION */}
          <div className="text-center max-w-5xl mx-auto mb-20">
            {/* TOP BADGE */}
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="inline-flex items-center gap-3 bg-white shadow-lg px-6 py-3 rounded-full mb-8 border border-[#e5ecff]"
            >
              <div className="w-11 h-11 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                <FaChartLine />
              </div>

              <span className="font-semibold text-[#0b1c39]">
                Wisdom Consultancy Knowledge Center
              </span>
            </motion.div>

            {/* HEADING */}
            <motion.h1
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-[#111]"
            >
              Financial{' '}
              <span className="text-[#69bf74]">
                Insights
              </span>{' '}
              & Expert Articles
            </motion.h1>

            {/* DESCRIPTION */}
            <motion.p
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="mt-8 text-lg md:text-xl text-gray-600 leading-9 max-w-4xl mx-auto"
            >
              Stay updated with expert investment strategies,
              mutual fund insights, insurance guidance, and
              smart financial planning tips to secure your
              future with confidence.
            </motion.p>
          </div>

          {/* BLOG GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
            {publishedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 35 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                className="group bg-white rounded-[34px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-transparent hover:border-[#dce7ff]"
              >
                {/* IMAGE */}
                {blog.image && (
                  <div className="relative h-60 overflow-hidden">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />

                    {/* OVERLAY */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />

                    {/* CATEGORY BADGE */}
                    <div className="absolute top-5 left-5 bg-white/90 backdrop-blur-md text-[#2e56b8] px-4 py-2 rounded-full text-xs font-semibold shadow-md">
                      Financial Insights
                    </div>
                  </div>
                )}

                {/* CONTENT */}
                <div className="p-8">
                  {/* META */}
                  <div className="flex flex-wrap gap-4 text-xs text-gray-500 mb-5">
                    <span className="flex items-center gap-2 bg-[#f7f9fc] px-3 py-2 rounded-full">
                      <FaCalendarAlt className="text-[#2e56b8]" />
                      {blog.createdAt}
                    </span>

                    <span className="flex items-center gap-2 bg-[#f7f9fc] px-3 py-2 rounded-full">
                      <FaUserAlt className="text-[#69bf74]" />
                      {blog.author}
                    </span>

                    <span className="flex items-center gap-2 bg-[#f7f9fc] px-3 py-2 rounded-full">
                      <FaEye className="text-[#2e56b8]" />
                      {blog.views} Views
                    </span>
                  </div>

                  {/* TITLE */}
                  <h2 className="text-2xl md:text-[28px] font-bold text-[#0b1c39] leading-snug mb-5 line-clamp-2 group-hover:text-[#2e56b8] transition-colors duration-300">
                    {blog.title}
                  </h2>

                  {/* EXCERPT */}
                  <p className="text-gray-600 leading-8 mb-7 line-clamp-3">
                    {blog.excerpt}
                  </p>

                  {/* TAGS */}
                  <div className="flex flex-wrap gap-3 mb-8">
                    {blog.tags?.slice(0, 3).map((tag, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-[#edf3ff] text-[#2e56b8] px-4 py-2 rounded-full font-semibold border border-[#dce7ff]"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>

                  {/* BUTTON */}
                  <Link
                    to={`/blogs/${blog.slug}`}
                    className="inline-flex items-center gap-3 text-[#2e56b8] font-bold text-lg hover:gap-5 transition-all duration-300"
                  >
                    Read Full Article
                    <FaArrowRight />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

          {/* EMPTY STATE */}
          {publishedBlogs.length === 0 && (
            <div className="text-center py-24">
              <div className="bg-white rounded-[35px] shadow-2xl p-14 max-w-3xl mx-auto border border-[#edf3ff]">
                <div className="w-20 h-20 rounded-full bg-[#edf3ff] flex items-center justify-center mx-auto mb-6 text-[#2e56b8] text-3xl">
                  <FaChartLine />
                </div>

                <h3 className="text-3xl md:text-4xl font-bold text-[#0b1c39] mb-5">
                  Blogs Coming Soon
                </h3>

                <p className="text-gray-600 text-lg leading-9 max-w-2xl mx-auto">
                  We are preparing expert financial articles,
                  investment tips, insurance guidance, and
                  wealth planning insights for you.
                  Stay connected with Wisdom Consultancy.
                </p>
              </div>
            </div>
          )}

          {/* CTA SECTION */}
          <div className="mt-24">
            <div className="bg-white rounded-[40px] shadow-2xl p-10 md:p-16 text-center border border-[#e7f0eb] relative overflow-hidden">
              
              {/* BACKGROUND SHAPES */}
              <div className="absolute top-0 right-0 w-72 h-72 bg-[#edf3ff] rounded-full blur-3xl opacity-50" />

              <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#dff5eb] rounded-full blur-3xl opacity-50" />

              <div className="relative z-10">
                {/* SMALL BADGE */}
                <div className="inline-flex items-center gap-3 bg-[#edf3ff] px-5 py-3 rounded-full mb-8">
                  <div className="w-10 h-10 rounded-full bg-[#2e56b8] flex items-center justify-center text-white">
                    <FaChartLine />
                  </div>

                  <span className="font-semibold text-[#0b1c39]">
                    Financial Growth & Investment Planning
                  </span>
                </div>

                {/* TITLE */}
                <h2 className="text-4xl md:text-5xl font-bold text-[#222] leading-tight mb-6">
                  Need Expert{' '}
                  <span className="text-[#69bf74]">
                    Financial Guidance?
                  </span>
                </h2>

                {/* DESCRIPTION */}
                <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-9 mb-10">
                  Connect with Wisdom Consultancy for smart
                  investment strategies, insurance planning,
                  mutual fund guidance, and long-term wealth
                  creation solutions.
                </p>

                {/* BUTTON */}
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white px-8 py-5 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg"
                >
                  Book Free Consultation
                  <FaArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blogs;